export const reduxKey = '@@notificationsQueue';
export const actionKey = '@@NOTIFICATIONS';
